// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import MeasurementDamageModel from '$models/measurement/MeasurementDamageModel';
import Config from '$root/Config';

// class definition
export default class MeasurementDamageCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || MeasurementDamageModel;
		args.config = {
			url: Config.getUrl('measurementDamage'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
